export default "__VITE_ASSET__62e42328__"